
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_nllvs_97",
  "variant-default": "awsui_variant-default_14iqq_nllvs_109",
  "variant-stacked": "awsui_variant-stacked_14iqq_nllvs_109",
  "header": "awsui_header_14iqq_nllvs_132",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_nllvs_137",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_nllvs_141",
  "header-stuck": "awsui_header-stuck_14iqq_nllvs_147",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_nllvs_152",
  "with-paddings": "awsui_with-paddings_14iqq_nllvs_158",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_nllvs_161",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_nllvs_165",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_nllvs_189",
  "dark-header": "awsui_dark-header_14iqq_nllvs_197",
  "content": "awsui_content_14iqq_nllvs_201",
  "footer": "awsui_footer_14iqq_nllvs_208",
  "with-divider": "awsui_with-divider_14iqq_nllvs_211"
};
  